import { getFileName, getMimeTypeFile } from '@crema/utility/Utils';
import { ADD_ATTACHMENT_PROGRAM_KERJA, DELETE_ATTACHMENT_PROGRAM_KERJA, GET_LIST_PROGRAM_KERJA, SET_ATTACHMENT_PROGRAM_KERJA } from 'shared/constants/ActionTypes';

const INIT_STATE = {
    data: {
        results: [],
    },
    attachments: [],
};

const programKerjaReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_PROGRAM_KERJA: {
            return {
                ...state,
                data: action.payload,
            }
        }
        case ADD_ATTACHMENT_PROGRAM_KERJA: {
            let attObj = {
                id: action.payload.id,
                file: action.payload.file,
                size: action.payload.file_size,    
                name: getFileName(action.payload.file),
                type: getMimeTypeFile(action.payload.file ,action.payload.mime_type), 
            }
            return {
                ...state,
                attachments: [...state.attachments, attObj],
            }
        }
        case SET_ATTACHMENT_PROGRAM_KERJA: {
            return {
                ...state,
                attachments: action.payload
            }
        }
        case DELETE_ATTACHMENT_PROGRAM_KERJA: {
            return {
                ...state,
                attachments: action.payload
            }
        }
        default:
            return state;
    }
};
export default programKerjaReducer;
